const inspirationClickMapper = require('./atmmapper/inspiration-atm-mapper').clickMapper;
const atmInternalCampaignMapper = require('../../../common/components/analytics/atm-mapper-internal-campaign');

module.exports = function ($state, $location, inspirationService, atm, $compile, breakpointsService) {
    return {
        restrict: 'E',
        scope: {
            card: '='
        },
        require: '?^wowCard',
        link(scope, element, cardCtrl) {

            scope.breakpointsService = breakpointsService;
            //the below is set as a standard for dynamic content team to use the service to get browser window widths
            // the team uses as: ng-if="breakpoints.isInMediumFormat || breakpoints.isInLargeFormat" or ng-if="breakpoints.isInSmallFormat"
            scope.breakpoints = breakpointsService;

            //If the page was navigated to via card URL, open card
            if (cardCtrl) {
                scope.$watch(function () { return $state.params.cardId; }, function () {
                    if ($state.params.cardId === scope.card.ID) {
                        cardCtrl.openCardDetail(scope.card.ID);
                    }
                });
            }

            scope.trackClick = (event) => {
                // Find the index of the current card in the card list
                const $card = $(event.currentTarget).closest('wow-card');
                const $cardList = $card.closest('wow-card-list');
                const index = $cardList.find('wow-card').index($card);

                atm.push({
                        type: event.data.type,
                        campaignName: event.data.campaignName,
                        position: index + 1
                    },
                    atmInternalCampaignMapper);
            };

            const addClickTracking = (card, $card) => {
                $card.on('click', 'a', { type: 'merch-card', campaignName: card.CampaignName }, scope.trackClick);
            };

            if (scope.card.ContentHtml) {
                const html = '<div class="inspirationCard card">' + scope.card.ContentHtml.replace(/<img\s/g, '<img loading="lazy" ') + '</div>';
                const $card = $compile(html)(scope);
                element.append($card);

                addClickTracking(scope.card, $card);
            }

            scope.linkHref = function () {
                return scope.card.CardLinkTarget || $state.href('shop.inspirationcard', {
                    id: scope.card.ID,
                    name: scope.card.UrlPart
                });
            };

            scope.goToCard = function ($event) {
                atm.push({ card: scope.card, position: cardCtrl ? cardCtrl.getPosition() : null, list: $location.path() }, inspirationClickMapper);

                if (scope.card.CardLinkTarget) {
                    inspirationService.setContentCardId(scope.card.ID);
                } else if (cardCtrl && $event.button === 0) {
                    $event.preventDefault();

                    // open the detail view if we are inside a card list and we left clicked the link
                    cardCtrl.openCardDetail(scope.card.ID, { cardId: scope.card.ID, name: scope.card.UrlPart });
                }
            };

            scope.selectedPointer = function () {
                return cardCtrl && cardCtrl.isDetailExpanded();
            };
        },
        template: require('./inspiration-card-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/inspiration/inspiration-card-directive.js
 **/